<template>
  <div class="collect">
    <el-col
      v-if="buttonList != null && buttonList.length > 0"
      :span="24"
      class="toolbar"
      style="padding-bottom: 0px"
    >
      <el-form :inline="true" @submit.native.prevent :model="filters">
        <el-form-item>
          <el-select
            v-model="filters.TopicName"
            placeholder="请输入投票活动名称"
            :loading="loadingTopicName"
            filterable
            clearable
            remote
            reserve-keyword
            :remote-method="remoteMethod"
          >
            <el-option
              v-for="item in TopicList"
              :key="item.TopicName"
              :label="item.TopicName"
              :value="item.TopicName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="filters.PhoneNumber"
            placeholder="手机号码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item v-for="item in buttonList" v-bind:key="item.id">
          <el-button
            :type="
              item.Func &&
              (item.Func.toLowerCase().indexOf('handledel') != -1 ||
                item.Func.toLowerCase().indexOf('stop') != -1)
                ? 'danger'
                : 'primary'
            "
            v-if="!item.IsHide"
            @click="callFunc(item)"
            >{{ item.name }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table
      :data="tabData"
      border=""
      v-loading="listLoading"
      ref="table"
      style="width: 100%"
      class="custom-tbl"
    >
      <!-- <el-table-column type="selection" width="50"></el-table-column> -->
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column prop="TopicName" label="课题名称" show-overflow-tooltip ></el-table-column>
      <el-table-column prop="Name" label="姓名" width="100"></el-table-column>
      <el-table-column prop="CompanyName" label="公司名称" width="200" ></el-table-column>
      <el-table-column prop="Position" label="职位" width="120"></el-table-column>
      <el-table-column prop="PhoneNumber" label="手机" width="100" ></el-table-column>
      <el-table-column prop="Email" label="邮箱" width="180"></el-table-column>
      <el-table-column prop="Type" label="申报课题类别" width="180"></el-table-column>
      <el-table-column prop="VoterPhoneNumber" label="投票人手机" width="100"></el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="filters.PageIndex"
        :page-size="filters.PageSize"
        :total="filters.total"
        style="float: right"
      ></el-pagination>
    </el-col>


  </div>
</template>

<script>
import { getButtonList } from '../../promissionRouter'
import { 
  getTopicNameList,
  getTopicVoteList
} from '../../api/api'
export default {
  data() {
    return {
      buttonList:[],
      filters:{
        PhoneNumber:'',
        TopicName:'',
        Type:'',
        OrderByFileds:'',
        Conditions:'',
        PageIndex: 1, //第几页
        PageSize: 20, // 每页多少条
        total: 0, // 总记录
        pageCount: 1,

      },
      loadingTopicName: false, // 适用活动 加载效果
      TopicList: [], // 适用活动
      tabData:[],
      listLoading: false
    }
  },
  methods:{
    // 按钮点击事件传值
    callFunc(item, row) {
      this.currentRow = row
      this[item.Func].apply(this, item)
    },

    // 查询
    handleQuery(){
      this.listLoading = true
      getTopicVoteList(this.filters).then((res) => {
        if (res.data.data) {
          this.tabData = res.data.data
          this.filters.total = res.data.dataCount
          this.filters.pageCount = res.data.pageCount
          this.listLoading = false
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },

    // 导出
    handleExport(){
      const token = window.localStorage.getItem('Token')
      const url = `${process.env.VUE_APP_BASE_API}/api/DataCollection/topic/vote/export`
      var xhr = new XMLHttpRequest()
      xhr.open('post', url, true)
      // 2.2 设置请求头,作用是设置参数的编码格式，以便后台能够正确的接收所传递的参数
      xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
      xhr.responseType = 'blob' // 返回类型blob
      xhr.setRequestHeader('Authorization', 'Bearer ' + token) // 携带token校验

      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response
          var reader = new FileReader()
          reader.readAsDataURL(blob) // 转换为base64
          reader.onload = function (e) {
            var a = document.createElement('a') // 创建一个a标签用于下载
            a.download = '评选列表' + new Date().getTime() + '.xls' //文件名
            a.href = e.target.result
            a.click()
            $(a).remove()
          }
        }
      }
      xhr.send(JSON.stringify(this.filters))
    },

    // 投票活动名称
    remoteMethod(query) {
      if (query !== '') {
        this.loadingTopicName = true
        setTimeout(() => {
          getTopicNameList(query).then((res) => {
            console.log('res', res)
            this.TopicList = res.data
            this.loadingTopicName = false
          })
        }, 500)
      }
    },

    // 翻页事件
    handleSizeChange(pageSize) {
      this.filters.PageSize = pageSize
      this.handleQuery()
    },
    // 翻页事件
    handleCurrentChange(currentPage) {
      this.filters.PageIndex = currentPage
      this.handleQuery()
    },
  },
  mounted(){
    this.handleQuery()

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    this.buttonList = getButtonList(this.$route.path, routers)
  }
}
</script>

<style>

</style>